import { render, staticRenderFns } from "./CopyGraderuleTermSlidebar.vue?vue&type=template&id=db728b06"
import script from "./CopyGraderuleTermSlidebar.vue?vue&type=script&lang=js"
export * from "./CopyGraderuleTermSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports